<template>
  <div class="perms">
    <div>
      <div
        v-for="(category, index) in categories"
        v-bind:key="index"
        class="mb-3"
      >
        <bold>{{ category }}</bold>

        <b-form-checkbox-group
          v-model="innerRoles"
          :options="innerAvailableRoles.filter((f) => f.category == category)"
          stacked
          switches
          @change="emit()"
          class="perms-switch mt-1"
          name="options"
        ></b-form-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { availableRoles: null, roles: null },
  watch: {
    roles: {
      handler(newRoles, oldVal) {
        this.innerRoles = newRoles;
      },

      immediate: true,
    },
  },
  data() {
    return {
      innerAvailableRoles: null,
      innerRoles: null,
      categories: null,
    };
  },
  created() {
    this.categories = [];

    this.availableRoles.forEach((f) => {
      if (this.categories.indexOf(f.category) == -1) {
        this.categories.push(f.category);
      }
    });

    this.innerAvailableRoles = this.availableRoles.map((m) => {
      return {
        text: m.description,
        value: m.key,
        sortId: m.sortId,
        category: m.category,
      };
    });
  },
  methods: {
    emit() {
      this.$emit("rolesUpdated", this.innerRoles);
    },
  },
};
</script>

<style>
.perms .custom-control-label span {
  margin-left: -15px;
}
.perms-switch {
  padding-left: 1.75em;
}
</style>
